var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<input type=\"text\" ng-attr-id=\"{{ vm.param_id }}\" ng-attr-name=\"{{ vm.param_id }}\" ng-attr-placeholder=\"{{ (vm.parameter[vm.key].options &amp;&amp; vm.parameter[vm.key].options.placeholder) ? vm.parameter[vm.key].options.placeholder : '' }}\" ng-model=\"vm.parameter[vm.key].wert\" ng-attr-maxlength=\"{{ vm.parameter[vm.key].maxlength }}\" ng-change=\"vm.change()\" class=\"form-control\">");;return buf.join("");
}